module.exports = __webpack_public_path__ + "assets/addonadas.415d1515.svg";